<template lang='pug'>
    v-form( ref='form' )

        template( v-if='false' )
            v-progress-linear( indeterminate )

        template( v-if='title' )
            v-container( fluid grid-layout-lg pa-4 )
                v-layout( row wrap align-center )
                    v-flex( xs12 sm6 )
                        h1.title {{ title }}
                    v-flex( xs12 sm6 )
                        slot( name='header-buttons' )
            v-divider
        
        v-container( fluid grid-layout-lg pt-4 px-4 )
            v-layout( row wrap )
                template( v-for='( item, index ) in items' )
                    v-flex( sm2 mt-1 pt-4 v-if='noFlex' )
                        strong( class="text-capitalize title" ) {{ item.field.label }}
                    v-flex( v-bind='noFlex ? defaultNoFlex : ( item.flex || defaultFlex )' )

                        template( v-if='item.type === "autocomplete"' )
                            model-autocomplete( v-bind='item.props' v-model='models[ item.name ]' )
                                strong( class='mr-1 mt-1 text-capitalize' slot='prepend-inner' v-if='!noFlex && !item.noPrepend' ) {{ item.props.label }}

                        template( v-else-if='item.type === "select"' )
                            v-select( single-line outline v-bind='item.props' v-model='models[ item.name ]' @keyup.enter='submit' )
                                strong( class='mr-1 mt-1 text-capitalize' slot='prepend-inner' v-if='!noFlex && !item.noPrepend' ) {{ item.props.label }}

                        template( v-else-if='item.type === "switch"' )
                            v-switch( v-bind='item.props' v-model='models[ item.name ]' )

                        template( v-else-if='item.type === "text"' )
                            v-text-field( single-line outline :mask='{ item, models } | mask' v-bind='item.props' v-model='models[ item.name ]' @keyup.enter='submit' )
                                strong( class='mr-1 mt-1 text-capitalize' slot='prepend-inner' v-if='!noFlex && !item.noPrepend' ) {{ item.props.label }}

                        template( v-else-if='item.type === "date"' )
                            v-dialog( full-width lazy width='290px' v-model='modals[ item.name ]' )
                                template( slot='activator' )
                                    v-text-field( single-line outline v-bind='item.props' v-model='models[ item.name ]' @keyup.enter='submit' append-icon="event" )
                                        strong( class='mr-1 mt-1 text-capitalize' slot='prepend-inner' v-if='!noFlex && !item.noPrepend' ) {{ item.props.label }}
                                v-date-picker( locale='es' scrollable v-bind='item.picker' v-model='models[ item.name ]' )

                        template( v-else-if='item.type === "slot"' )
                            slot( :name=' "slot-" + item.name ' )

                    v-flex( xs1 v-if='noFlex' )

                v-flex( xs12 text-xs-center v-if='!noActions' )
                    v-btn( @click='reset' ) {{ resetText }}
                    v-btn( color='secondary' @click='submit' ) {{ submitText }}
</template>

<script>
    //
    import ModelAutocomplete from './ModelAutocomplete'
    //
    export default {
        components: {
            'model-autocomplete': ModelAutocomplete,
        },
        created () {

            /**
             * 
             */
            this.defaultFlex = {
                lg3: true,
                md4: true,
                sm6: true,
                xs12: true,
            }
            
            /**
             * 
             */
            this.defaultNoFlex = {
                sm3: true,
            }

            /**
             * 
             */
            this.rebuild()
        },
        data () {
            return {
                modals: {},
                models: {},
            }
        },
        filters: {

            /**
             * 
             */
            isAutocomplete ( item ) {
                return item.type === 'autocomplete'
            },
            
            /**
             * 
             */
            isText ( item ) {
                return item.type === 'text'
            },

            /**
             * 
             */
            mask ({ models, item }) {

                //
                const value         = models[ item.name ] || ''
                    , valueString   = String( value )

                //
                switch ( item.format ) {
                    case 'currency': return '$ ' + Array.from( Array( valueString.length ).fill( '#', 0 ), ( v, i ) => i > 0 && i%3 === 0 ? '.' + v : v ).join( '' ).split( '' ).reverse().join( '' )
                }

                //
                return undefined
            },
        },
        methods: {

            /**
             * 
             */
            rebuild () {
                this.modals = this.items.reduce( this.reduceModals, {} )
                this.models = this.items.reduce( this.reduceModels, {} )
            },

            /**
             * 
             */
            reduceModals ( total, curr ) {
                return {
                    ...total,
                    [ curr.name ]: curr.type !== 'date',
                }
            },
            
            /**
             * 
             */
            reduceModels ( total, curr ) {
                return {
                    ...total,
                    [ curr.name ]: curr.value,
                }
            },

            /**
             * 
             */
            reset () {
                this.rebuild()
                this.$emit( 'reset', { data: this.models } );
            },

            /**
             * 
             */
            setValue ( name, value ) {
                this.models[ name ] = value
            },

            /**
             * 
             */
            submit () {
                if ( this.validate() ) {
                    this.$emit( 'submit', { data: this.models } ); console.log( 'submit form', this.models );
                }
            },

            /**
             * 
             */
            validate () {
                return this.$refs.form.validate()
            },
        },
        mounted () {
            this.reset()
        },
        props: {

            /**
             * 
             */
            noActions   : Boolean,
            noFlex      : Boolean,

            /**
             * 
             */
            items: Array,

            /**
             * 
             */
            resetText: String,

            /**
             * 
             */
            submitText: String,

            /**
             * 
             */
            title: String,
        },
        watch: {

            /**
             * 
             */
            items () {
                this.submit()
            },
        },
    }
</script>
